export const COMBO_KEY = 'combo';
export const TREE_KEY = 'tree';
//# sourceMappingURL=graphlib.js.map